'use client';

import { FilesIcon } from 'lucide-react';
import { useState } from 'react';

interface Props {
  text: string;
  label?: string; // optional aria-label
}

export default function CopyButton({ text, label = 'Copy' }: Props) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // reset after 1.5 s
    } catch {
      /* ignore or add toast */
    }
  }

  return (
    <button
      type="button"
      aria-label={label}
      onClick={handleCopy}
      className="text-neutral-400 hover:text-neutral-50 transition-colors"
    >
      <FilesIcon
        width={16}
        height={16}
        className={copied ? 'text-emerald-400' : undefined}
      />
    </button>
  );
}
